import { useResize } from "./useResize";

export const BREAKPOINTS = {
	mobile: 768,
	tablet: 1024,
	smallDesktop: 1240,
} as const;

export interface IResponsiveInfo {
	isMobile: boolean;
	isTablet: boolean;
	isSmallDesktop: boolean;
	width: number;
	height: number;
}

export const useMobile = (): IResponsiveInfo => {
	const { width, height } = useResize();
	return {
		isMobile: width <= BREAKPOINTS.mobile,
		isTablet: width <= BREAKPOINTS.tablet,
		isSmallDesktop: width <= BREAKPOINTS.smallDesktop,
		width,
		height,
	};
};
